export default {
  android: 'https://play.google.com/store/apps/details?id=br.com.leiaonline',
  ios: 'https://apps.apple.com/us/app/id1523870579',
};
